import './styles.sass'
import * as content from './content'
import React,{Component} from 'react'
import classnames from 'classnames'

class Hero extends Component
	render: ()->
		<div className="hero">
			<div className="hero-bg"></div>
			<div className="hero-innerwrap">
				<a href="/">
					<img className="hero-logo" src="/files/img/logo.svg" />
				</a>
				
				<Content />
				<div className="hero-content-divider"></div>
				<Price />
				<Cta />
				
				<img className="hero-items" src="/files/img/hero-items.png" />
			</div>
		</div>


export Content = ()->
	<div className="hero-content">
		<h1 className="hero-title" dangerouslySetInnerHTML={__html:content.title} />
		<div className="hero-body" dangerouslySetInnerHTML={__html:content.body} />
	</div>

export Price = ({centered})->
	<div className={classnames "hero-price", {centered}}>
		<div className="hero-price-current">${content.price.current}</div>
		<div className="hero-price-subtext">
			<div className="hero-price-label">{content.price.label}</div>
			<div className="hero-price-previous">${content.price.previous} Original Price</div>
		</div>
		<div className="hero-price-altProduct">{content.altProduct}</div>
	</div>


export Cta = ({centered})->
	handleClick = ()->
		window.ga?('send', 'event', 
			transport: 'beacon'
			eventAction: 'click'
			eventCategory: 'Clicked CTA'
		)
	
	<div className={classnames "hero-cta", {centered}}>
		<a className="hero-button" href="/purchase?freetrial=1" onClick={handleClick}>{content.cta}</a>
	</div>


export default Hero
